/**
 * Erros que o interceptor Axios já notifica via toast.
 * Evita Message duplicado na UI quando o toast já cobriu o caso.
 */
export function isAxiosErrorAlreadyToasted(err: unknown): boolean {
  const anyErr = err as { code?: string; response?: { status?: number } } | null | undefined;
  if (anyErr?.code === 'ERR_NETWORK') {
    return true;
  }
  const status = anyErr?.response?.status;
  return (
    status === 400 ||
    status === 403 ||
    status === 404 ||
    status === 415 ||
    status === 422 ||
    status === 500
  );
}
